"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _path;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_path || (_path = /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.205 5.599c.954.954 1.415 2.279 1.42 3.614 0 3.065-2.204 5.726-4.138 7.501-1.215 1.116-2.554 2.14-3.98 2.973l-.507.314-.501-.309c-.975-.562-1.888-1.227-2.765-1.93-1.14-.911-2.46-2.127-3.502-3.553-1.038-1.418-1.86-3.124-1.86-4.995-.002-1.251.394-2.59 1.42-3.615a4.859 4.859 0 016.87 0l.335.335.336-.335c1.873-1.872 5-1.873 6.872 0zM11.998 17.65c.67-.43 1.91-1.284 3.137-2.41 1.878-1.725 3.488-3.87 3.49-6.026-.005-.85-.265-1.633-.834-2.202-1.104-1.103-2.941-1.1-4.045.002l-1.751 1.744-1.746-1.746a2.859 2.859 0 00-4.044 0c-1.683 1.684-.53 4.414.641 6.016.9 1.23 2.073 2.32 3.137 3.172a24.383 24.383 0 002.015 1.45z"
  }))];
};

exports.default = _default;